import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import './MitraIndustri.css';
import 'swiper/css';

// Komponen internal untuk Slider agar bisa digunakan ulang
const PartnerSlider = ({ items, loading, reverse = false }) => {
  const swiperRef = useRef(null);

  if (loading) {
    return (
      <div className="mitra-slider-skeleton">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="mitra-logo-skeleton" />
        ))}
      </div>
    );
  }

  if (!items || items.length === 0) return <p className="text-center text-muted">Belum ada mitra di kategori ini.</p>;

  // Duplikasi item agar loop berjalan mulus (Marquee effect) walaupun datanya sedikit
  const displayItems = items.length < 5 ? [...items, ...items, ...items, ...items] : [...items, ...items];

  return (
    <div className="mitra-slider-container">
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Autoplay]}
        spaceBetween={60}
        slidesPerView={'auto'}
        loop={true}
        centeredSlides={false} // Diubah agar lebih mudah digeser dari tepi
        allowTouchMove={true}
        autoplay={{
          delay: 1, // Delay 1 lebih stabil untuk animasi continuous (marquee)
          disableOnInteraction: false,
          reverseDirection: reverse,
          pauseOnMouseEnter: true, // Otomatis berhenti saat di-hover
        }}
        speed={5000}
        className="mitra-swiper"
      >
        {displayItems.map((partner, index) => (
          <SwiperSlide key={`${partner.id}-${index}`} className="mitra-slide">
            <div className="mitra-logo">
              <img src={partner.logoUrl} alt={partner.name} loading="lazy" />
              <p>{partner.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const MitraIndustri = ({ partners, loading }) => {
  // Filter mitra berdasarkan kategori
  // Jika kategori tidak ada (data lama), anggap sebagai 'Hotel'
  const hotelPartners = partners.filter(p => !p.category || p.category === 'Hotel');
  const tourismPartners = partners.filter(p => p.category === 'Pariwisata');

  if (!loading && partners.length === 0) {
    return null;
  }

  return (
    <section className="section mitra-section">
      <div className="container">
        <h2>Mitra Industri</h2>

        <div className="mitra-category-group">
          <h3 className="mitra-category-title">Mitra Perhotelan</h3>
          <PartnerSlider items={hotelPartners} loading={loading} />
        </div>

        <div className="mitra-category-group" style={{ marginTop: '40px' }}>
          <h3 className="mitra-category-title">Mitra Pariwisata</h3>
          <PartnerSlider items={tourismPartners} loading={loading} reverse={true} />
        </div>

      </div>
    </section>
  );
};

export default MitraIndustri;